import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { login } from 'app/shared/reducers/authentication';
import LoginModal from '../login/login-modal';

export const LoginBooking = ({ parentClose, bookingId, fetchUserData }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const loginError = useAppSelector(state => state.authentication.loginError);
  const showModalLogin = useAppSelector(state => state.authentication.showModalLogin);
  const [showModal, setShowModal] = useState(showModalLogin);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setShowModal(true);
  }, []);

  const handleLogin = (username, password, rememberMe = false) => {
    dispatch(login(username, password, rememberMe));
    navigate(`/booking/${bookingId}`);
  };

  const handleClose = () => {
    setShowModal(false);
    parentClose();
    navigate(`/booking/${bookingId}`);
  };

  const { from } = (location.state as any) || { from: { pathname: '/', search: location.search } };
  if (isAuthenticated) {
    //fetchUserData();
    return <Navigate to={from} replace />;
    //return <Navigate to={`/booking/${bookingId}`} replace />;
  }
  return <LoginModal showModal={showModal} handleLogin={handleLogin} handleClose={handleClose} loginError={loginError} />;
};

export default LoginBooking;
